{
  "name": "@uppy/store-redux",
  "description": "Make Uppy use your existing Redux store.",
  "version": "4.1.2",
  "license": "MIT",
  "main": "lib/index.js",
  "type": "module",
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "redux"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "dependencies": {
    "nanoid": "^5.0.9"
  },
  "devDependencies": {
    "jsdom": "^26.1.0",
    "redux": "^4.0.0",
    "vitest": "^3.2.4"
  },
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build",
    "test": "vitest run --environment=jsdom --silent='passed-only'"
  }
}
